import type { Template } from "@/types";

export const SQ_03_H0_V3: Template[] = [
    {
        id: "sq-03-h0v3-01",
        name: "SQ 01 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 123, y: 62, width: 391, height: 593, rotation: 0, imageRotation: 0 },
            { id: "2", x: 522, y: 62, width: 391, height: 593, rotation: 0, imageRotation: 0 },
            { id: "3", x: 921, y: 62, width: 390, height: 593, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-02",
        name: "SQ 02 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 282, y: 142, width: 285, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 575, y: 142, width: 285, height: 433, rotation: 0, imageRotation: 0 },
            { id: "3", x: 868, y: 142, width: 285, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-03",
        name: "SQ 03 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 473, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 481, y: 0, width: 473, height: 717, rotation: 0, imageRotation: 0 },
            { id: "3", x: 962, y: 0, width: 472, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-04",
        name: "SQ 04 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 169, y: 128, width: 303, height: 462, rotation: 0, imageRotation: 0 },
            { id: "2", x: 481, y: 0, width: 472, height: 717, rotation: 0, imageRotation: 0 },
            { id: "3", x: 962, y: 128, width: 303, height: 462, rotation: 0, imageRotation: 0 },  
        ],
    },

    {
        id: "sq-03-h0v3-05",
        name: "SQ 05 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 123, y: 0, width: 472, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 771, y: 129, width: 304, height: 462, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1083, y: 129, width: 303, height: 462, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-06",
        name: "SQ 06 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 209, y: 135, width: 303, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 771, y: 135, width: 304, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1083, y: 135, width: 303, height: 450, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-07",
        name: "SQ 07 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 58, width: 403, height: 605, rotation: 0, imageRotation: 0 },
            { id: "2", x: 455, y: 58, width: 402, height: 605, rotation: 0, imageRotation: 0 },
            { id: "3", x: 998, y: 135, width: 300, height: 450, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-08",
        name: "SQ 08 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 56, y: 135, width: 301, height: 450, rotation: 0, imageRotation: 0 },
            { id: "2", x: 365, y: 135, width: 300, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 0, width: 510, height: 717, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-09",
        name: "SQ 09 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 60, y: 0, width: 596, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 770, y: 135, width: 301, height: 450, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1079, y: 135, width: 300, height: 450, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-03-h0v3-10",
        name: "SQ 10 - H0V3",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-03-h0_v3_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 96, y: 129, width: 302, height: 460, rotation: 0, imageRotation: 0 },
            { id: "2", x: 484, y: 0, width: 472, height: 717, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1041, y: 129, width: 302, height: 460, rotation: 0, imageRotation: 0 },
        ],
    },
];
